module.exports = __webpack_public_path__ + "svg/flags/Sint Maarten (Dutch part).svg";